import { UPDATE_ALL, visitorActionTypes } from './types'



export function updateVisitorAll(value: any): visitorActionTypes {
    return {
        type: UPDATE_ALL,
        payload: value
    };
}